import Vue from 'vue'
import App from './App.vue'
import Axios from "axios";
import store from './store'
import VueRouter from 'vue-router';
import router from "@/routes";
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'bootstrap-vue/dist/bootstrap-vue-icons.min.css'

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.use(VueRouter)

Vue.config.productionTip = false

Vue.prototype.$http = Axios;

const token = localStorage.getItem('usertoken')

if (token) {
  Vue.prototype.$http.defaults.headers.common['Authorization'] = token
}

new Vue({
  render: h => h(App),
  router,
  store
}).$mount('#app')
